import React, { useState } from 'react'
import { proxyStorageUrl } from '../../../lib/supabase'

export default function PaymentsList({
  isAdmin,
  loading,
  payments,
  wbDeductions,
  manualHours,
  filterEmployee,
  employees,
  profile,
  autoSalary,
  today,
  firstDayOfMonth,
  lastDayOfMonth,
  formatMoney,
  formatDate,
  formatDateTime,
  renderEvidence,
  typeConfig,
  setCommentModal,
  setImagePreviewModal,
  setDisputeId,
  setDisputeToResolve,
  handleEdit,
  setItemToDelete,
  filterPeriodStart,
  filterPeriodEnd,
  handleResolveManualHour
}) {
  const [showAllRecords, setShowAllRecords] = useState(false)

  // Объединяем корректировки и удержания
  const allRecords = [
    ...payments.map(p => ({ ...p, _source: 'payment' })),
    ...wbDeductions.map(d => ({ ...d, _source: 'deduction', type: `deduction_${d.type}`, employee_name: employees.find(e => e.id === d.employee_id)?.name || 'Сотрудник' }))
  ].sort((a, b) => {
    const dateA = a._source === 'deduction' ? a.date : a.created_at
    const dateB = b._source === 'deduction' ? b.date : b.created_at
    return dateB.localeCompare(dateA)
  })

  const hasMore = allRecords.length > 3
  const visibleRecords = showAllRecords ? allRecords : allRecords.slice(0, 3)

  return (
    <div className="payments-list-section animate-fade-in" style={{ marginTop: '24px' }}>
      
      {/* 11a: Подтверждение ручных часов сотрудника (для админа) */}
      {isAdmin && manualHours.length > 0 && (
        <div className="card animate-fade-in" style={{ marginBottom: '16px', border: '1px solid var(--wb-primary)', background: 'rgba(203,17,171,0.02)' }}>
          <h3 className="payments-list-title" style={{ padding: '12px 16px 0 16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle'}}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></span> Заявки на ручное добавление часов ({manualHours.length})
          </h3>
          <div style={{ display: 'flex', flexDirection: 'column', padding: '8px 16px 16px 16px', gap: '10px' }}>
            {manualHours.map((h) => {
              const empName = employees.find(e => e.id === h.employee_id)?.name || 'Сотрудник'
              return (
                <div key={h.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: 'var(--surface)', padding: '10px 14px', borderRadius: '12px', border: '1px solid var(--surface-border)' }}>
                  <div>
                    <div style={{ fontWeight: 600, fontSize: '14px' }}>{empName}</div>
                    <div style={{ fontSize: '11px', color: 'var(--text-secondary)', marginTop: '2px' }}>
                      Дата: <strong>{formatDate(h.date)}</strong> · Отработано: <strong>{Number(h.hours).toFixed(1).replace(/\.0$/, '')} ч</strong>
                    </div>
                    {h.comment && <div style={{ fontSize: '12px', fontStyle: 'italic', color: 'var(--text-secondary)', marginTop: '4px' }}>«{h.comment}»</div>}
                  </div>
                  <div style={{ display: 'flex', gap: '6px' }}>
                    <button className="btn btn-sm btn-primary" style={{ padding: '6px 12px' }} onClick={() => handleResolveManualHour(h.employee_id, h.date, 'approved')}>Подтвердить</button>
                    <button className="btn btn-sm btn-ghost" style={{ padding: '6px 12px', color: 'var(--danger)' }} onClick={() => handleResolveManualHour(h.employee_id, h.date, 'rejected')}>Отклонить</button>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* 11b: История выплат ЗП для сотрудника */}
      {!isAdmin && (() => {
        const salaryPayments = payments.filter(p => p.type === 'salary' && (p.status === 'paid' || p.status === 'approved'))
        const filterStart = filterPeriodStart || today()
        const filterEnd = filterPeriodEnd || today()
        const latestPaidThrough = salaryPayments.reduce((latest, p) => {
          return (p.period_end && (!latest || p.period_end > latest)) ? p.period_end : latest
        }, '')
        
        const totalEarned = autoSalary?.total || 0
        let totalPaid = 0
        let remaining = totalEarned
        
        if (latestPaidThrough && latestPaidThrough >= filterEnd) {
          totalPaid = totalEarned
          remaining = 0
        } else if (latestPaidThrough && latestPaidThrough >= filterStart) {
          totalPaid = salaryPayments.reduce((s, p) => s + parseFloat(p.amount), 0)
          remaining = Math.max(0, totalEarned - totalPaid)
        }
        
        const isPaidFully = remaining <= 0 && totalPaid > 0
        
        return (
          <div className="card animate-fade-in" style={{ marginBottom: '16px', padding: '16px' }}>
            <h3 className="payments-list-title" style={{ marginBottom: '12px' }}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg> История выплат ЗП ({salaryPayments.length})
            </h3>
            {salaryPayments.length === 0 ? (
              <div style={{ textAlign: 'center', padding: '16px', color: 'var(--text-secondary)' }}>
                <div>Выплат за этот период пока нет</div>
              </div>
            ) : (
              <>
                {salaryPayments.map((p, i) => (
                  <div key={p.id} style={{
                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                    padding: '10px 12px', borderRadius: '12px',
                    background: 'var(--surface-hover)', marginBottom: '6px'
                  }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: '14px' }}>
                        {p.comment || (i === 0 ? 'Аванс' : 'Выплата')}
                      </div>
                      <div style={{ fontSize: '12px', color: 'var(--text-secondary)' }}>
                        {new Date(p.created_at).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })}
                        {p.period_start && ` · за ${new Date(p.period_start).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })} — ${new Date(p.period_end).toLocaleDateString('ru-RU', { day: 'numeric', month: 'short' })}`}
                      </div>
                    </div>
                    <div style={{ fontWeight: 700, fontSize: '16px', color: 'var(--success)' }}>
                      +{formatMoney(parseFloat(p.amount))}
                    </div>
                  </div>
                ))}
                <div style={{
                  display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  padding: '12px', borderRadius: '14px', marginTop: '8px',
                  background: isPaidFully ? 'rgba(34, 197, 94, 0.1)' : 'rgba(234, 179, 8, 0.1)',
                  border: `1px solid ${isPaidFully ? 'rgba(34, 197, 94, 0.3)' : 'rgba(234, 179, 8, 0.3)'}`
                }}>
                  <div style={{ fontWeight: 600 }}>
                    {isPaidFully ? <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle',marginRight:'4px'}}><polyline points="20 6 9 17 4 12"/></svg> Полностью оплачено</> : remaining > 0 ? <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle',marginRight:'4px'}}><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg> Остаток: {formatMoney(remaining)}</> : <><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle',marginRight:'4px'}}><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg> Выплачено</>}
                  </div>
                  <div style={{ fontWeight: 700, fontSize: '16px' }}>
                    {formatMoney(totalPaid)}
                  </div>
                </div>
              </>
            )}
          </div>
        )
      })()}

      <h3 className="payments-list-title"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg> Все записи ({allRecords.length})</h3>
      {loading ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div className="skeleton-pulse" style={{ height: '80px', borderRadius: 'var(--border-radius-lg)' }}></div>
          <div className="skeleton-pulse" style={{ height: '80px', borderRadius: 'var(--border-radius-lg)' }}></div>
        </div>
      ) : allRecords.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg></div>
          <div className="empty-state-title">Нет записей</div>
          <div className="empty-state-text">
            {isAdmin ? 'Здесь будут отображаться все премии, штрафы и удержания' : 'Здесь будут ваши премии, штрафы и удержания'}
          </div>
        </div>
      ) : (
        visibleRecords.map((record, index) => {
          const tc = typeConfig[record.type]
          if (!tc) return null
          const isDeduction = record._source === 'deduction'
          return (
            <div key={`${record._source}-${record.id}`} className="payment-card card" style={{ animationDelay: `${index * 30}ms` }}>
              <div className="payment-card-left">
                <div className="payment-type-badge" style={{ background: tc.bgColor, color: tc.color }}>
                  <span>{tc.icon}</span><span>{tc.label}</span>
                </div>
                <div className="payment-info">
                  <div className="payment-employee">{record.employee_name}</div>
                  <div className="payment-period"> {isDeduction ? new Date(record.date).toLocaleDateString('ru') : `${formatDate(record.period_start)} — ${formatDate(record.period_end)}`}</div>
                  {record.comment && <div className="payment-comment" style={{ cursor: record.comment.length > 40 ? 'pointer' : 'default' }} onClick={() => record.comment.length > 40 && setCommentModal({ text: record.comment, title: `${tc.label}: ${record.employee_name}` })}>{record.comment.length > 60 ? record.comment.slice(0,57)+'...' : record.comment}</div>}
                  {renderEvidence(record.video_url, setImagePreviewModal)}
                  {record.status === 'disputed' && (
                    <div style={{ color: 'orange', fontWeight: 'bold', fontSize: '11px', marginTop: '4px', background: 'rgba(255,165,0,0.1)', padding: '6px 8px', borderRadius: '4px' }}>
                      <div>ОСПАРИВАЕТСЯ: {record.dispute_comment}</div>
                      
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '6px' }}>
                        {record.dispute_evidence_url && (() => {
                          const cleanUrl = record.dispute_evidence_url.split('?')[0].toLowerCase()
                          const isVideo = cleanUrl.endsWith('.mp4') || cleanUrl.endsWith('.mov') || cleanUrl.endsWith('.avi') || cleanUrl.endsWith('.webm') || cleanUrl.endsWith('.mkv') || cleanUrl.includes('/video')
                          return (
                            <div 
                              style={{ cursor: 'pointer' }}
                              onClick={(e) => { e.stopPropagation(); setImagePreviewModal(proxyStorageUrl(record.dispute_evidence_url)); }}
                            >
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', color: 'var(--text-primary)', fontSize: '10px', background: 'var(--surface-hover)', padding: '4px 8px', borderRadius: '4px', border: '1px solid var(--border-color)' }}>
                                {isVideo ? (
                                  <>
                                    <span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle',marginRight:'4px'}}><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/></svg> Видеодоказательство</span>
                                  </>
                                ) : (
                                  <>
                                    <span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle',marginRight:'4px'}}><rect x="3" y="3" width="18" height="18" rx="2" ry="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg> Фотодоказательство:</span>
                                    <img src={proxyStorageUrl(record.dispute_evidence_url)} alt="" style={{ width: '24px', height: '24px', objectFit: 'cover', borderRadius: '4px' }} />
                                  </>
                                )}
                              </div>
                            </div>
                          )
                        })()}

                        {record.dispute_video_url && (
                          <a 
                            href={proxyStorageUrl(record.dispute_video_url)} 
                            target="_blank" 
                            rel="noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            style={{ display: 'flex', alignItems: 'center', gap: '4px', color: 'var(--wb-primary, #6b21a8)', fontSize: '10px', background: 'var(--surface-hover)', padding: '4px 8px', borderRadius: '4px', border: '1px solid var(--border-color)', textDecoration: 'none' }}
                          >
                            <span><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle',marginRight:'4px'}}><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg> Видео по ссылке</span>
                          </a>
                        )}
                      </div>
                    </div>
                  )}
                  {record.status === 'rejected' && <div style={{ color: 'gray', fontWeight: 'bold', fontSize: '11px', marginTop: '4px' }}><svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle',marginRight:'4px'}}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>ОТМЕНЁН</div>}
                  {renderEvidence(record.evidence_url, setImagePreviewModal)}
                </div>
              </div>
              <div className="payment-card-right">
                <div className="payment-amount" style={{
                  color: record.status === 'rejected' ? 'var(--text-secondary)' : (record.type === 'bonus' || record.type === 'salary' ? 'var(--success)' : 'var(--danger)'),
                  textDecoration: record.status === 'rejected' ? 'line-through' : 'none'
                }}>
                  {record.type === 'bonus' ? '+' : '−'}{formatMoney(parseFloat(record.amount))}
                </div>
                <div className="payment-meta">
                  {!isDeduction && <span className="payment-created">{formatDateTime(record.created_at)}</span>}
                  {!isDeduction && record.created_by_name && <span className="payment-author">от {record.created_by_name}</span>}
                  {isDeduction && <span className="payment-author" style={{ fontSize: '10px', background: tc.bgColor, color: tc.color, padding: '2px 6px', borderRadius: '4px' }}>Удержание WB</span>}
                </div>
                {isAdmin && (
                  <div style={{ display: 'flex', gap: '4px', flexDirection: 'column' }}>
                    {record.status === 'disputed' ? (
                      <>
                        <button className="btn btn-primary btn-sm" style={{ fontSize: '10px', padding: '4px 8px' }} onClick={() => setDisputeToResolve({ id: record.id, isApproved: true, source: record._source })}>Оставить</button>
                        <button className="btn btn-danger btn-sm" style={{ fontSize: '10px', padding: '4px 8px' }} onClick={() => setDisputeToResolve({ id: record.id, isApproved: false, source: record._source })}>Отменить</button>
                      </>
                    ) : (
                      <div style={{ display: 'flex', gap: '4px' }}>
                        {record.type !== 'salary' && (
                          <button className="btn btn-ghost btn-sm payment-delete" onClick={() => handleEdit(record)} title="Редактировать"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg></button>
                        )}
                        <button className="btn btn-ghost btn-sm payment-delete" onClick={() => setItemToDelete({ id: record.id, source: record._source })} title="Удалить"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg></button>
                      </div>
                    )}
                  </div>
                )}
                {record.employee_id === profile?.id && (record.type === 'fine' || isDeduction) && record.status !== 'disputed' && record.status !== 'rejected' && (
                  <button className="btn btn-ghost btn-sm" style={{ color: 'orange', fontSize: '11px', padding: '4px 8px' }} onClick={() => setDisputeId({ id: record.id, source: record._source })}>Оспорить</button>
                )}
              </div>
            </div>
          )
        })
      )}
      {hasMore && !showAllRecords && (
        <button
          className="btn btn-ghost"
          onClick={() => setShowAllRecords(true)}
          style={{ 
            width: '100%', padding: '12px', marginTop: '8px',
            fontSize: '13px', color: 'var(--wb-primary)',
            border: '1px dashed var(--surface-border)',
            borderRadius: 'var(--border-radius-md)',
          }}
        >
          Показать ещё ({allRecords.length - 3}) <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{verticalAlign:'middle',marginLeft:'4px'}}><polyline points="6 9 12 15 18 9"/></svg>
        </button>
      )}
    </div>
  )
}
